import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import heroAtto1 from '../images/kv-pc.jpg';
import exteriorAtto1 from '../images/07-01-pc-01.webp';
import interiorAtto1 from '../images/10-pc.jpg';
import fiturAtto1 from '../images/08-01-pc-03.webp';
import PageSeo, {
  articleJsonLd,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
  productJsonLd,
} from '../PageSeo';

function HargaAtto1Junius() {
  const waLink =
    'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20ingin%20info%20harga%20BYD%20Atto%201%20untuk%20BSD%2C%20Tangerang%2C%20atau%20Gading%20Serpong';

  const pricingCards = [
    {
      variant: 'Dynamic',
      price: 'Mulai Rp205 juta*',
      points: [
        'Range hingga 300 km NEDC.',
        'Blade Battery 30.08 kWh.',
        'Paling cocok untuk komuter harian dan mobilitas kota.',
      ],
    },
    {
      variant: 'Premium',
      price: 'Mulai Rp241 juta*',
      points: [
        'Range hingga 380 km NEDC.',
        'Blade Battery 38.88 kWh.',
        'Fitur kabin lebih lengkap untuk pemakaian lebih fleksibel.',
      ],
    },
  ];

  const serviceAreas = [
    {
      area: 'BSD Serpong',
      description:
        'Intent paling dekat ke showroom. Cocok untuk query seperti BYD Atto 1 BSD, harga BYD Atto 1 BSD, dan test drive BYD Atto 1 BSD Serpong.',
    },
    {
      area: 'Tangerang',
      description:
        'Halaman ini juga melayani pencarian dari Tangerang dan Tangerang Selatan yang sudah masuk tahap cek harga, promo, atau simulasi pembelian.',
    },
    {
      area: 'Gading Serpong',
      description:
        'Untuk pencari BYD Atto 1 Gading Serpong, halaman ini menjelaskan bahwa showroom BSD Serpong tetap relevan sebagai lokasi konsultasi, unit display, dan booking test drive.',
    },
  ];

  const supportCards = [
    {
      image: exteriorAtto1,
      title: 'Cek harga terbaru dan promo',
      description:
        'Halaman ini difokuskan untuk intent yang sudah dekat ke transaksi, jadi user bisa langsung lanjut ke promo, ketersediaan unit, dan penawaran terbaru.',
    },
    {
      image: interiorAtto1,
      title: 'Bandingkan varian sebelum datang',
      description:
        'Dynamic dan Premium punya perbedaan yang penting untuk dibahas sebelum booking unit, terutama soal range, fitur, dan budget.',
    },
    {
      image: fiturAtto1,
      title: 'Booking test drive lebih cepat',
      description:
        'Untuk pengunjung dari BSD, Tangerang, atau Gading Serpong, halaman ini sengaja diarahkan agar langkah berikutnya jelas: tanya harga lalu atur jadwal test drive.',
    },
  ];

  const relatedLinks = [
    {
      title: 'Halaman utama BYD Atto 1',
      path: '/jelajahi-atto1',
      description:
        'Buka halaman utama untuk spesifikasi, warna, fitur, dan overview BYD Atto 1.',
    },
    {
      title: 'Konsultasi dengan Junius',
      path: '/blog/byd-atto-1-bsd-serpong-junius',
      description:
        'Halaman support untuk kontak langsung, follow up pembelian, dan bantuan test drive.',
    },
    {
      title: 'Lihat pilihan warna BYD Atto 1',
      path: '/blog/pilihan-warna-byd-atto1',
      description:
        'Bagus untuk user yang sudah dekat ke pembelian dan ingin memastikan warna favorit.',
    },
  ];

  const faqItems = [
    {
      question: 'Berapa harga BYD Atto 1 di BSD Serpong?',
      answer:
        'Kisaran harga indikatif BYD Atto 1 saat ini mulai sekitar Rp205 juta untuk Dynamic dan Rp241 juta untuk Premium. Harga dapat berubah mengikuti promo, OTR, dan ketersediaan unit.',
    },
    {
      question: 'Apakah halaman ini cocok untuk pencarian BYD Atto 1 Tangerang?',
      answer:
        'Ya. Halaman ini dibuat untuk intent lokal-komersial dari Tangerang dan Tangerang Selatan yang membutuhkan harga, promo, dan langkah test drive dari showroom BSD Serpong.',
    },
    {
      question: 'Kalau saya cari BYD Atto 1 Gading Serpong, apakah tetap relevan?',
      answer:
        'Tetap relevan. Showroom BSD Serpong melayani pembeli dari Gading Serpong sehingga halaman ini membantu menjawab harga, ketersediaan unit, dan proses pembelian tanpa membuat halaman kota yang duplikat.',
    },
    {
      question: 'Apakah bisa booking test drive BYD Atto 1?',
      answer:
        'Bisa. Anda dapat menghubungi Junius untuk mengecek slot test drive, ketersediaan unit, dan opsi kunjungan ke showroom.',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <PageSeo
        title='Harga BYD Atto 1 BSD Serpong | Promo, Test Drive, Tangerang 2026'
        description='Cari harga BYD Atto 1 BSD, Tangerang, atau Gading Serpong? Cek kisaran harga, promo, area layanan, dan booking test drive BYD Atto 1 bersama Junius di BYD BSD Serpong.'
        keywords={[
          ...keywordSets.localDealer,
          'harga BYD Atto 1 BSD',
          'harga BYD Atto 1 BSD Serpong',
          'BYD Atto 1 BSD',
          'BYD Atto 1 Tangerang',
          'BYD Atto 1 Gading Serpong',
          'promo BYD Atto 1 BSD Serpong',
          'test drive BYD Atto 1 Tangerang',
        ]}
        path='/blog/harga-byd-atto-1-bsd-serpong-junius'
        image={heroAtto1}
        type='article'
        jsonLd={[
          localBusinessJsonLd(),
          productJsonLd({
            name: 'BYD Atto 1',
            description:
              'Harga BYD Atto 1 untuk pembeli BSD, Tangerang, dan Gading Serpong dengan kisaran Dynamic dan Premium.',
            image: heroAtto1,
            path: '/blog/harga-byd-atto-1-bsd-serpong-junius',
            lowPrice: 205000000,
            highPrice: 241000000,
            offerCount: 2,
          }),
          articleJsonLd({
            title: 'Harga BYD Atto 1 BSD Serpong | Promo, Test Drive, Tangerang 2026',
            description:
              'Landing page lokal-komersial untuk harga BYD Atto 1 di BSD Serpong, Tangerang, dan Gading Serpong.',
            image: heroAtto1,
            path: '/blog/harga-byd-atto-1-bsd-serpong-junius',
            datePublished: '2026-04-21',
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog', path: '/blog' },
            {
              name: 'Harga BYD Atto 1 BSD Serpong',
              path: '/blog/harga-byd-atto-1-bsd-serpong-junius',
            },
          ]),
          faqJsonLd,
        ]}
      />

      <Box component='main' sx={{ width: '100%', overflow: 'hidden' }}>
        <HeroSection waLink={waLink} />
        <PricingSection pricingCards={pricingCards} />
        <ServiceAreaSection serviceAreas={serviceAreas} />
        <SupportSection supportCards={supportCards} />
        <ResourceSection relatedLinks={relatedLinks} />
        <FaqSection faqItems={faqItems} />
        <CtaSection waLink={waLink} />
      </Box>
    </>
  );
}

function HeroSection({ waLink }) {
  return (
    <Box
      component='section'
      aria-labelledby='hero-harga-atto1-title'
      sx={{
        position: 'relative',
        minHeight: { xs: '88vh', md: '95vh' },
        display: 'flex',
        alignItems: 'flex-end',
        pt: { xs: 10, md: 11 },
        backgroundColor: '#111827',
      }}
    >
      <Box
        component='img'
        src={heroAtto1}
        alt='Harga BYD Atto 1 BSD Serpong'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.42) 0%, rgba(0,0,0,0.18) 42%, rgba(0,0,0,0.8) 100%)',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 1180,
          mx: 'auto',
          px: { xs: 2, md: 5 },
          pb: { xs: 5, md: 7 },
          color: '#fff',
        }}
      >
        <Typography
          sx={{
            display: 'inline-flex',
            px: 1.2,
            py: 0.65,
            borderRadius: '999px',
            backgroundColor: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.2)',
            fontSize: '0.78rem',
            fontWeight: 900,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
          }}
        >
          BYD BSD Serpong
        </Typography>
        <Typography
          id='hero-harga-atto1-title'
          component='h1'
          sx={{
            mt: 1.6,
            fontSize: { xs: '2.2rem', sm: '3.2rem', md: '4.8rem' },
            fontWeight: 900,
            lineHeight: 0.98,
            maxWidth: 860,
          }}
        >
          Harga BYD Atto 1 untuk BSD, Tangerang, dan Gading Serpong
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 760,
            fontSize: { xs: '1rem', md: '1.08rem' },
            lineHeight: 1.8,
            color: 'rgba(255,255,255,0.9)',
          }}
        >
          Halaman ini difokuskan untuk pencarian yang sudah dekat ke transaksi:
          harga BYD Atto 1, promo, simulasi pembelian, dan booking test drive
          dari showroom BYD BSD Serpong.
        </Typography>

        <Box
          sx={{
            mt: 2.5,
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          {['BSD Serpong', 'Tangerang', 'Gading Serpong', 'Test Drive'].map(
            (chip) => (
              <Box
                key={chip}
                sx={{
                  px: 1.4,
                  py: 0.8,
                  borderRadius: '999px',
                  border: '1px solid rgba(255,255,255,0.24)',
                  backgroundColor: 'rgba(0,0,0,0.34)',
                  fontWeight: 800,
                  fontSize: '0.9rem',
                }}
              >
                {chip}
              </Box>
            ),
          )}
        </Box>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: 1,
            maxWidth: 760,
          }}
        >
          {[
            { label: 'Harga mulai', value: 'Rp205 juta*' },
            { label: 'Varian', value: 'Dynamic & Premium' },
            { label: 'Range', value: '300-380 km NEDC' },
          ].map((item) => (
            <Box
              key={item.label}
              sx={{
                border: '1px solid rgba(255,255,255,0.22)',
                backgroundColor: 'rgba(0,0,0,0.34)',
                borderRadius: '8px',
                px: 1.8,
                py: 1.4,
              }}
            >
              <Typography sx={{ fontSize: '1.18rem', fontWeight: 900 }}>
                {item.value}
              </Typography>
              <Typography sx={{ fontSize: '0.82rem', opacity: 0.82 }}>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={{
              px: 3.2,
              py: 1.1,
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 900,
              backgroundColor: '#1f5fd1',
              '&:hover': { backgroundColor: '#184ca8' },
            }}
          >
            Tanya Harga via WhatsApp
          </Button>
          <Button
            component={RouterLink}
            to='/jelajahi-atto1'
            variant='outlined'
            sx={{
              px: 3.2,
              py: 1.1,
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 900,
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.72)',
              '&:hover': {
                borderColor: '#fff',
                backgroundColor: 'rgba(255,255,255,0.12)',
              },
            }}
          >
            Lihat halaman utama Atto 1
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function PricingSection({ pricingCards }) {
  return (
    <Box
      component='section'
      aria-labelledby='pricing-local-atto1-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography
          sx={{
            color: '#4c5867',
            fontWeight: 800,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            fontSize: '0.82rem',
          }}
        >
          Harga Indikatif
        </Typography>
        <Typography
          id='pricing-local-atto1-title'
          component='h2'
          sx={{
            mt: 1,
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            color: '#111827',
            lineHeight: 1.05,
            maxWidth: 860,
          }}
        >
          Harga BYD Atto 1 untuk user yang sudah siap masuk tahap pembelian
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 840,
            color: '#4b5563',
            lineHeight: 1.75,
          }}
        >
          Berbeda dari halaman produk utama, section ini sengaja dibuat untuk
          pengguna yang sudah mencari harga, promo, atau simulasi pembelian.
          Jadi copy dan CTA di sini lebih dekat ke tindakan komersial.
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 2.5,
          }}
        >
          {pricingCards.map((card) => (
            <Box
              key={card.variant}
              sx={{
                p: { xs: 2.2, md: 2.8 },
                borderRadius: '8px',
                border: '1px solid rgba(17,24,39,0.08)',
                backgroundColor: '#f8fafc',
                boxShadow: '0 12px 28px rgba(16,24,40,0.06)',
              }}
            >
              <Typography
                sx={{
                  fontSize: '0.82rem',
                  fontWeight: 900,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: '#2d6cdf',
                }}
              >
                Varian
              </Typography>
              <Typography
                component='h3'
                sx={{
                  mt: 0.6,
                  fontSize: { xs: '1.6rem', md: '1.9rem' },
                  fontWeight: 900,
                  color: '#111827',
                }}
              >
                {card.variant}
              </Typography>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: '1.05rem',
                  fontWeight: 900,
                  color: '#11805a',
                }}
              >
                {card.price}
              </Typography>
              <Box component='ul' sx={{ mt: 2, mb: 0, pl: 2.4, color: '#111827' }}>
                {card.points.map((point) => (
                  <Box
                    component='li'
                    key={point}
                    sx={{ mb: 0.8, lineHeight: 1.6, color: '#4b5563' }}
                  >
                    {point}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>

        <Typography sx={{ mt: 2, color: '#6b7280', fontSize: '0.92rem' }}>
          *Harga indikatif OTR BSD Serpong dan dapat berubah sewaktu-waktu.
        </Typography>
      </Box>
    </Box>
  );
}

function ServiceAreaSection({ serviceAreas }) {
  return (
    <Box
      component='section'
      aria-labelledby='service-area-atto1-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#f4f7fb',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography
          sx={{
            color: '#4c5867',
            fontWeight: 800,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            fontSize: '0.82rem',
          }}
        >
          Area Layanan
        </Typography>
        <Typography
          id='service-area-atto1-title'
          component='h2'
          sx={{
            mt: 1,
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            color: '#111827',
            lineHeight: 1.05,
            maxWidth: 860,
          }}
        >
          Satu halaman harga yang menangkap BSD, Tangerang, dan Gading Serpong
        </Typography>
        <Typography sx={{ mt: 1.5, maxWidth: 860, color: '#4b5563', lineHeight: 1.75 }}>
          Ini pendekatan yang lebih aman dibanding bikin banyak city-page yang
          hanya ganti nama area. Kontennya tetap unik, lokal, dan diarahkan ke
          showroom yang benar-benar melayani wilayah tersebut.
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {serviceAreas.map((item) => (
            <Box
              key={item.area}
              sx={{
                p: 2.4,
                borderRadius: '8px',
                border: '1px solid rgba(17,24,39,0.08)',
                backgroundColor: '#fff',
                boxShadow: '0 12px 26px rgba(16,24,40,0.06)',
              }}
            >
              <Typography
                sx={{
                  color: '#2d6cdf',
                  fontSize: '0.82rem',
                  fontWeight: 900,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                }}
              >
                {item.area}
              </Typography>
              <Typography sx={{ mt: 1.1, color: '#4b5563', lineHeight: 1.7 }}>
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function SupportSection({ supportCards }) {
  return (
    <Box
      component='section'
      aria-labelledby='support-atto1-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography
          id='support-atto1-title'
          component='h2'
          sx={{
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            color: '#111827',
            lineHeight: 1.05,
            maxWidth: 820,
          }}
        >
          Tiga hal yang biasanya dicari sebelum user kirim chat
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {supportCards.map((item) => (
            <Box
              key={item.title}
              sx={{
                overflow: 'hidden',
                borderRadius: '8px',
                border: '1px solid rgba(17,24,39,0.08)',
                boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
              }}
            >
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                sx={{
                  width: '100%',
                  height: 240,
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2.3, backgroundColor: '#fff' }}>
                <Typography sx={{ fontSize: '1.2rem', fontWeight: 900, color: '#111827' }}>
                  {item.title}
                </Typography>
                <Typography sx={{ mt: 1, color: '#4b5563', lineHeight: 1.7 }}>
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function ResourceSection({ relatedLinks }) {
  return (
    <Box
      component='section'
      aria-labelledby='resource-harga-atto1-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#111827',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto', color: '#fff' }}>
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.72)',
            fontWeight: 800,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            fontSize: '0.82rem',
          }}
        >
          Langkah Berikutnya
        </Typography>
        <Typography
          id='resource-harga-atto1-title'
          component='h2'
          sx={{
            mt: 1,
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            lineHeight: 1.05,
            maxWidth: 840,
          }}
        >
          Internal link yang menjaga intent tiap halaman tetap jelas
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {relatedLinks.map((link) => (
            <Box
              key={link.path}
              sx={{
                p: 2.4,
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.12)',
                backgroundColor: 'rgba(255,255,255,0.05)',
              }}
            >
              <Typography sx={{ fontSize: '1.2rem', fontWeight: 900 }}>
                {link.title}
              </Typography>
              <Typography
                sx={{
                  mt: 1,
                  color: 'rgba(255,255,255,0.76)',
                  lineHeight: 1.7,
                }}
              >
                {link.description}
              </Typography>
              <Button
                component={RouterLink}
                to={link.path}
                variant='text'
                sx={{
                  mt: 1.2,
                  px: 0,
                  textTransform: 'none',
                  fontWeight: 900,
                  color: '#9bc2ff',
                }}
              >
                Buka halaman
              </Button>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function FaqSection({ faqItems }) {
  return (
    <Box
      component='section'
      aria-labelledby='faq-harga-atto1-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}
    >
      <Box sx={{ maxWidth: 980, mx: 'auto' }}>
        <Typography
          id='faq-harga-atto1-title'
          component='h2'
          sx={{
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            color: '#111827',
            lineHeight: 1.05,
          }}
        >
          FAQ harga BYD Atto 1
        </Typography>
        <Box sx={{ mt: 2.5, display: 'grid', gap: 1.4 }}>
          {faqItems.map((item) => (
            <Box
              key={item.question}
              component='details'
              sx={{
                p: 2.1,
                borderRadius: '8px',
                backgroundColor: '#f8fafc',
                border: '1px solid rgba(17,24,39,0.08)',
                '& summary': {
                  cursor: 'pointer',
                  fontWeight: 900,
                  color: '#111827',
                },
              }}
            >
              <Box component='summary'>{item.question}</Box>
              <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.75 }}>
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function CtaSection({ waLink }) {
  return (
    <Box
      component='section'
      aria-labelledby='cta-harga-atto1-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#f4f7fb',
      }}
    >
      <Box
        sx={{
          maxWidth: 980,
          mx: 'auto',
          textAlign: 'center',
          p: { xs: 2.5, md: 4 },
          borderRadius: '8px',
          backgroundColor: '#fff',
          border: '1px solid rgba(17,24,39,0.08)',
          boxShadow: '0 12px 28px rgba(16,24,40,0.08)',
        }}
      >
        <Typography
          id='cta-harga-atto1-title'
          component='h2'
          sx={{
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 900,
            color: '#111827',
          }}
        >
          Mau harga BYD Atto 1 yang paling update?
        </Typography>
        <Typography
          sx={{
            mt: 2,
            mx: 'auto',
            maxWidth: 760,
            color: '#4b5563',
            lineHeight: 1.75,
          }}
        >
          Hubungi Junius untuk cek promo, simulasi cicilan, ketersediaan warna,
          dan jadwal test drive BYD Atto 1 dari showroom BSD Serpong untuk area
          BSD, Tangerang, dan Gading Serpong.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            justifyContent: 'center',
            gap: 1.5,
            flexWrap: 'wrap',
          }}
        >
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={{
              px: 4,
              py: 1.25,
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 800,
              backgroundColor: '#1f5fd1',
              '&:hover': { backgroundColor: '#184ca8' },
            }}
          >
            Chat WhatsApp Harga Atto 1
          </Button>
          <Button
            component={RouterLink}
            to='/jelajahi-atto1'
            variant='outlined'
            sx={{
              px: 4,
              py: 1.25,
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 800,
              color: '#1f5fd1',
              borderColor: 'rgba(31,95,209,0.36)',
              '&:hover': {
                borderColor: '#1f5fd1',
                backgroundColor: '#edf4ff',
              },
            }}
          >
            Kembali ke halaman utama
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default HargaAtto1Junius;
